const PBB_BANNER_REDIRECT_KEY = 'pbbBannerRedirect';

export function setPBBBannerRedirect(locationId: string, pageOrigin: string) {
  localStorage.setItem(PBB_BANNER_REDIRECT_KEY, JSON.stringify({ locationId, pageOrigin }));
}

export function getPBBBannerRedirect() {
  const redirectData = localStorage.getItem(PBB_BANNER_REDIRECT_KEY);
  if (!redirectData) {
    return null;
  }

  try {
    return JSON.parse(redirectData);
  } catch {
    return null;
  }
}

export function removePBBBannerRedirect() {
  localStorage.removeItem(PBB_BANNER_REDIRECT_KEY);
}
